module.exports = __webpack_public_path__ + "static/logo-6216c2cc6381944bf3d5c13b1c63f1ad.svg";